import { Box } from "@mui/material";
import Breakpoint from "@entrilia/shared/components/Breakpoint";
import useClientPageTitle from "../../../contexts/useClientPageTitle";
import MessagesListComponentDesktop from "../messagesList/desktop/MessagesListComponent";
import MessageListView from "../messagesList/listView/MessageListView";
import SearchComponent from "../search/SearchComponent";

const Messages = () => {
  useClientPageTitle("Inbox");

  return (
    <Box sx={{ display: "flex", width: "100%", flex: 1 }}>
      <Breakpoint from="sm" to="lg">
        <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
          <SearchComponent />
          <MessageListView />
        </Box>
      </Breakpoint>
      <Breakpoint from="lg">
        <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
          <SearchComponent />
          <MessagesListComponentDesktop />
        </Box>
      </Breakpoint>
    </Box>
  );
};

export default Messages;
